import React from 'react';

/** Neutral single-colour marks for the coding agents (currentColor, no brand art). */
export function ClaudeCodeMark({ size = 14, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden className={className}>
      <path d="M12 3v18M3 12h18M5.6 5.6l12.8 12.8M18.4 5.6 5.6 18.4" />
    </svg>
  );
}

export function CursorMark({ size = 14, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" aria-hidden className={className}>
      <path d="M12 2.5 20.5 7.5v9L12 21.5 3.5 16.5v-9z" />
      <path d="M3.5 7.5 12 12.5l8.5-5M12 12.5v9" />
    </svg>
  );
}
